import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f574f94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(['label', { required: _ctx.required }])
    }, _toDisplayString(_ctx.label), 3),
    _createElementVNode("div", {
      ref: "editorDiv",
      class: _normalizeClass(['editor__ref', {disabled: _ctx.disabled}])
    }, null, 2)
  ]))
}